












































































































































import {Component, Vue} from 'vue-property-decorator';
import {譲渡履歴検索条件型, 譲渡履歴レコード型, 譲渡履歴検索条件バリデータ一覧, 譲渡履歴検索結果型} from '@/type/stock/devolve/history/item';
import {譲渡書出力依頼型} from '@/type/stock/devolve/input/item';

import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import moment from 'moment';
import {progress} from '@/script/progress';
import {loginModule} from '@/store/authentication/login';
import {ValidationResult} from '@/type/validation/result';

import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import StockDepartmentSelector from '@/views/stock/StockDepartmentSelector.vue';
import StockUserSelector from '@/views/stock/StockUserSelector.vue';
import TransferMedicalSelector from '@/components/transfermedical/TransferMedicalSelector.vue';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalButton,
    AlertDialog,
    ConfirmDialog,
    StockDepartmentSelector,
    StockUserSelector,
    TransferMedicalSelector,
  },
})
export default class ListDevolveHistories extends Vue {

  private 譲渡履歴一覧: 譲渡履歴レコード型[] = [];
  private 譲渡履歴検索条件: 譲渡履歴検索条件型 = this.検索条件初期値を取得();
  private 譲渡書印刷対象: 譲渡履歴レコード型 | null = null;

  private 検索条件バリデーション結果: ValidationResult = new ValidationResult(譲渡履歴検索条件バリデータ一覧);

  private アラートメッセージ: string | string[] | null = null;

  private 選択行番号: number | null = null;

  private 検索条件初期値を取得(): 譲渡履歴検索条件型 {
    return {
      部署コード: loginModule.部署コードを取得する,
      譲渡日付FROM: moment().startOf('month').toDate(),
      譲渡日付TO: null,
      メーカー名: '',
      商品名カナ: '',
      譲渡医療機関コード: '',
      登録者コード: loginModule.管理者である ? '' : loginModule.利用者コードを取得する,
      譲渡伝票番号: null,
    };
  }

  private beforeUpdate() {
    this.検索条件バリデーション結果.validate(this.譲渡履歴検索条件);
  }

  private 検索条件エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  private APIアラートダイアログを開く(data: any) {
    this.アラートメッセージ = this.APIアラートメッセージを取得(data);
    this.$modal.show('アラート');
  }

  private APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    if (!data.errors) {
      return メッセージ;
    }
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }

  private created(): void {
    moment.locale('ja');
    this.initialize();
  }

  private initialize() {
    this.譲渡履歴検索条件 = this.検索条件初期値を取得();
    this.譲渡履歴一覧 = [];
    this.アラートメッセージ = null;
    this.選択行番号 = null;
  }

  private バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private クリアする(): void {
    this.initialize();
    this.ダイアログを閉じる('クリアダイアログ');
  }

  private async 譲渡検索ハンドラ() {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.譲渡履歴検索);
  }

  private async 譲渡履歴検索(): Promise<void> {
    if (!this.譲渡履歴検索条件) {
      return;
    }
    this.譲渡履歴一覧 = [];

    await api.譲渡履歴を検索する(this.譲渡履歴検索条件)
            .then((response: 譲渡履歴検索結果型) => {
              this.譲渡履歴一覧 = response.譲渡履歴レコード一覧;
              if (this.譲渡履歴一覧.length === 0) {
                this.アラートメッセージ = '検索結果が0件です。';
                this.$modal.show('アラート');
                return;
              }
              if (response.アラートメッセージ) {
                this.アラートメッセージ = response.アラートメッセージ;
                this.$modal.show('アラート');
              }
            }).catch((error: any) => {
              this.APIアラートダイアログを開く(error.data);
              this.譲渡履歴一覧 = [];
            });
  }

  private 読取専用でない(譲渡履歴: 譲渡履歴レコード型) {
    if (譲渡履歴.読取専用フラグ === '読取専用でない') {
      return true;
    }
    return false;
  }

  private async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    this.ダイアログを開く('出力ダイアログ');
  }

  private async 出力するハンドラ(): Promise<void> {
    await progress(this.出力する);
  }

  private async 出力する(): Promise<void> {
    await download.譲渡履歴照会一覧表を出力する('譲渡履歴照会一覧.xlsx', this.譲渡履歴検索条件)
            .catch((error: any) => {
              this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
              this.$modal.show('アラート');
            });
    this.ダイアログを閉じる('出力ダイアログ');
  }

  private async 譲渡書出力ハンドラ(譲渡履歴: 譲渡履歴レコード型) {
    this.譲渡書印刷対象 = 譲渡履歴;
    await progress(this.譲渡書を出力する);
  }

  private async 譲渡書を出力する(): Promise<void> {
    if (this.譲渡書印刷対象 === null) {
      this.アラートメッセージ = '出力対象が選択されていません';
      this.$modal.show('アラート');
      return;
    }

    const ファイル名: string = '譲渡書_' + moment().format('YYYYMMDDhhmmss') + '.pdf';
    const 譲渡書出力依頼: 譲渡書出力依頼型 = {譲渡伝票番号: this.譲渡書印刷対象.譲渡伝票番号};
    await download.譲渡書を出力する(ファイル名, 譲渡書出力依頼);
    this.譲渡書印刷対象 = null;
  }

  private 行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  private 行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

}
